aracwebshop.ProductList = class {
	/* Options:
		- items: Items
		- settings: Aracwebshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not list view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "List View") {
			this.products_section.addClass("hidden");
		}

		this.products_section.empty();
		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 200 ? title.substr(0, 200) + "..." : title;
			const item_code = this.escape_attr(item.item_code || "");
			const route = this.safe_internal_url(item.route);

			html += `<div class="list-row flex flex-col sm:flex-row gap-6 bg-white border border-slate-100 rounded-3xl !p-5 shadow-[0_8px_30px_rgb(0,0,0,0.02)] hover:shadow-[0_20px_40px_rgba(0,0,0,0.06)] transition-all duration-300 relative group item-card" data-item-code="${item_code}" data-route="${route}">`;
			html += me.get_image_html(item, title, me.settings);
			html += me.get_row_body_html(item, title, me.settings);
			html += `</div>`;
		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);
	}

	get_image_html(item, title, settings) {
		const raw_image = window.aracwebshopImages
			? window.aracwebshopImages.get_listing_image(item)
			: (item.thumbnail || item.website_image);
		const image = this.safe_image_url(raw_image);
		const route = this.safe_internal_url(item.route);
		const safe_title_attr = this.escape_attr(title);
		const wishlist_enabled = !item.has_variants && settings.enable_wishlist;
		const wishlist_html = wishlist_enabled ? this.get_wishlist_icon(item) : '';

		// Generate badges
		let badges_html = "";
		if (item.custom_promo_badge) {
			badges_html += `
				<button type="button" class="promo-badge-trigger bg-slate-900 text-amber-300 text-[10px] font-black uppercase tracking-wide px-2.5 py-1 rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.4)] flex items-center gap-1.5 cursor-pointer pointer-events-auto hover:bg-slate-800 hover:scale-105 active:scale-95 transition-all duration-200 border border-amber-400/50 whitespace-nowrap"
					data-promo-title="${this.escape_attr(item.custom_promo_badge)}" data-promo-detail="${this.escape_attr(item.custom_promo_detail || '')}">
					<svg class="w-3 h-3 text-amber-400 shrink-0" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M5 5a3 3 0 015-3c1.756 0 3 1.244 3 3 0 .552-.15 1.07-.41 1.513A4.985 4.985 0 0115 10v5a2 2 0 01-2 2H7a2 2 0 01-2-2v-5c0-1.306.5-2.498 1.32-3.393A2.96 2.96 0 015 5zm3-1a1 1 0 100 2h.01a1 1 0 100-2H8z" clip-rule="evenodd" />
					</svg>
					${this.escape_html(item.custom_promo_badge)}
				</button>
			`;
		}

		if (item.is_best_seller) {
			badges_html += `<span class="bg-[#009688] text-white text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded-md shadow-sm">Bestseller</span>`;
		} else if (item.campaign_badge) {
			const bg = this.safe_color(item.campaign_badge.badge_bg_color, "#4f46e5");
			const fg = this.safe_color(item.campaign_badge.badge_text_color, "#ffffff");
			badges_html += `<span style="background-color: ${bg} !important; color: ${fg} !important;" class="text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded-md shadow-sm">${this.escape_html(item.campaign_badge.title)}</span>`;
		}

		if (item.formatted_price) {
			if (item.formatted_mrp) {
				badges_html += `<span class="bg-rose-500 text-white text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded-md shadow-sm">Sale</span>`;
			}
			
			// Dynamic "New" badge based on manual flag OR creation date (within last 30 days)
			let is_new = false;
			if (item.custom_is_new === 1 || item.custom_is_new === true) {
				is_new = true;
			} else if (item.creation) {
				const created_date = new Date(item.creation);
				const diff_time = Math.abs(new Date() - created_date);
				const diff_days = Math.ceil(diff_time / (1000 * 60 * 60 * 24));
				if (diff_days <= 30) {
					is_new = true;
				}
			}

			if (is_new) {
				badges_html += `<span class="bg-theme-primary text-white text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded-md shadow-sm">New</span>`;
			}


		}

		if (settings.enabled && !item.has_variants && item.in_cart) {
			const template_code = window.aracwebshopPrice.escape_attr(item.item_code || "");
			badges_html += `
				<span class="bg-emerald-500 text-white text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded-md shadow-sm flex items-center gap-1" data-item-code="${template_code}">
					<svg class="w-2.5 h-2.5 text-white shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007z" />
					</svg>
					<span>${this.escape_html(__("In Cart"))}</span>
				</span>
			`;
		}

		const is_rtl = document.documentElement.dir === "rtl" || document.body.dir === "rtl" || window.getComputedStyle(document.documentElement).direction === "rtl" || (document.documentElement.lang || "en").toLowerCase().startsWith("ar");
		const position_style = is_rtl ? "right: 0.75rem !important; left: auto !important; align-items: flex-end !important;" : "left: 0.75rem !important; right: auto !important; align-items: flex-start !important;";
		const badge_container = badges_html ? `
			<div class="absolute top-3 flex flex-col gap-1.5 z-10 pointer-events-none" style="${position_style}">
				${badges_html}
			</div>
		` : "";
		const variant_cart_qty = parseFloat(item.variant_in_cart_qty || 0) || 0;
		let template_cart_indicator = "";
		if (item.has_variants && settings.enabled) {
			const template_code = this.escape_attr(item.item_code || "");
			const hidden_class = variant_cart_qty > 0 ? "" : "hidden";
			const in_cart_color = this.safe_color(settings.custom_theme_in_cart_color, "#059669");
			template_cart_indicator = `
				<button type="button" class="arac-template-cart-badge btn-explore-variants absolute bottom-3 right-3 rtl:right-auto rtl:left-3 w-8 h-8 md:w-9 md:h-9 text-white rounded-full flex items-center justify-center shadow-lg z-10 cursor-pointer hover:scale-105 transition-transform select-none ${hidden_class}"
					style="background-color: ${in_cart_color} !important; color: #ffffff !important; border: 2px solid #ffffff !important; box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15) !important;"
					data-template-item-code="${template_code}" data-template-cart-qty="${variant_cart_qty}" data-item-code="${template_code}" data-route="${route}" aria-label="${this.escape_attr(__("View variants in cart"))}">
					<span class="arac-template-cart-qty cart-qty-display font-extrabold text-xs md:text-sm leading-none text-center flex items-center justify-center w-full h-full select-none" style="color: #ffffff !important;">${parseInt(variant_cart_qty, 10)}</span>
				</button>
			`;
		}

		if (image) {
			return `
				<div class="relative w-full sm:w-44 aspect-square overflow-hidden rounded-[1.5rem] bg-slate-50 flex items-center justify-center flex-shrink-0">
					<a href="${route}" class="w-full h-full flex items-center justify-center">
						<img itemprop="image" class="arac-product-card-image object-cover w-full h-full group-hover:scale-105 transition-transform duration-500" src="${image}" data-arac-image-src="${image}" alt="${safe_title_attr}" loading="lazy" decoding="async">
					</a>
					${ wishlist_html }
					${ badge_container }
					${ template_cart_indicator }
				</div>
			`;
		} else {
			const abbreviation = this.escape_html(frappe.get_abbr(title));
			return `
				<div class="relative w-full sm:w-44 aspect-square overflow-hidden rounded-[1.5rem] bg-gradient-to-br from-slate-50 to-slate-100/80 flex items-center justify-center flex-shrink-0 group-hover:bg-gradient-to-br group-hover:from-theme-primary-light group-hover:to-theme-primary-light transition-colors duration-500">
					<a href="${route}" class="w-full h-full flex items-center justify-center">
						<div class="w-14 h-14 rounded-2xl bg-white shadow-sm flex items-center justify-center text-theme-primary font-extrabold text-sm tracking-wider transform group-hover:scale-110 transition-transform duration-500 border border-slate-100">
							${abbreviation}
						</div>
					</a>
					${ wishlist_html }
					${ badge_container }
					${ template_cart_indicator }
				</div>
			`;
		}
	}

	get_row_body_html(item, title, settings) {
		let body_html = `<div class="flex flex-col flex-grow text-left justify-between min-w-0">`;
		body_html += `
			<div>
				<div class="flex flex-col sm:flex-row justify-between items-start gap-2 mb-2">
					<a href="${this.safe_internal_url(item.route)}" class="hover:text-theme-primary transition-colors">
						<h3 class="text-base font-bold text-slate-800 leading-snug">${this.escape_html(title)}</h3>
					</a>
					<span class="text-[10px] font-bold text-theme-primary uppercase tracking-widest px-2.5 py-1 bg-theme-primary-light rounded-lg shrink-0">${this.escape_html(item.item_group || '')}</span>
				</div>
				<p class="text-xs text-slate-400 mb-2">${this.escape_html(__('Item Code'))} : <span class="font-semibold">${this.escape_html(item.item_code)}</span></p>
		`;

		if (settings.enable_reviews) {
			const avg_rating = flt(item.average_rating) || 0.0;
			const filled_stars = Math.round(avg_rating);
			let stars_html = "";
			for (let i = 1; i <= 5; i++) {
				if (i <= filled_stars) {
					stars_html += `<svg class="w-3.5 h-3.5 fill-current text-amber-400" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>`;
				} else {
					stars_html += `<svg class="w-3.5 h-3.5 fill-current text-slate-200" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>`;
				}
			}
			body_html += `
				<div class="flex items-center gap-1 mb-2">
					<div class="flex">
						${stars_html}
					</div>
					<span class="text-[10px] font-semibold text-slate-400">(${avg_rating.toFixed(1)})</span>
				</div>
			`;
		}

		body_html += `
				<p class="text-xs text-slate-500 line-clamp-2 mb-4">${this.escape_html(item.short_description || '')}</p>
			</div>
		`;

		body_html += `<div class="flex flex-wrap items-center justify-between gap-4 mt-auto border-t border-slate-100 pt-4">`;
		if (item.formatted_price) {
			body_html += this.get_price_html(item);
		} else {
			const price_label = item.has_variants ? __("Price varies by option") : __("Price on request");
			body_html += `
				<div class="flex items-baseline gap-2">
					<span class="text-xs font-semibold text-slate-400 italic">${this.escape_html(price_label)}</span>
				</div>
			`;
		}
		body_html += this.get_stock_availability(item, settings);

		const use_dropdown = settings.show_uom_in_dropdown;
		const uom_html = this.get_uom_selection(item, settings);
		const button_html = this.get_primary_button(item, settings);

		if (use_dropdown && uom_html) {
			// Dropdown mode: UOM dropdown (60%) + button (40%)
			body_html += `
				<div class="flex items-center gap-2 w-full sm:w-auto sm:min-w-[280px] justify-end ml-auto">
					<div class="flex-[3] min-w-0">${ uom_html }</div>
					<div class="flex-[2]">${ button_html }</div>
				</div>
			`;
		} else {
			// Chip/non-dropdown mode: UOM chips and button side-by-side, aligned to the right (end of card)
			body_html += `
				<div class="flex flex-wrap items-center gap-3 w-full sm:w-auto justify-end ml-auto">
					${ uom_html }
					${ button_html }
				</div>
			`;
		}
		body_html += `</div></div>`;
		return body_html;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "fill-red-500 stroke-red-500 wished" : "stroke-slate-400 fill-none group-hover/wish:stroke-red-500 not-wished";
		return `
			<button class="absolute top-3 right-3 p-2 bg-white/80 hover:bg-white backdrop-blur-sm rounded-full shadow-sm hover:scale-105 active:scale-95 transition-all duration-200 z-10 group/wish like-action-list ${ item.wished ? 'like-action-wished' : ''}" data-item-code="${this.escape_attr(item.item_code)}">
				<svg class="w-4 h-4 ${ icon_class } wish-icon transition-colors duration-200" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none">
					<path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
				</svg>
			</button>
		`;
	}

	get_price_html(item) {
		const price_info = window.aracwebshopPrice.get_initial_price(item || {});
		const initial_price = window.aracwebshopPrice.escape_attr(price_info.display);
		const base_formatted = window.aracwebshopPrice.escape_attr(price_info.base_formatted);

		let price_html = `
			<div class="flex items-baseline gap-2">
				<span class="text-base font-extrabold text-slate-900 product-card-price" data-base-formatted="${ base_formatted }">${ initial_price || '' }</span>
		`;

		if (item.formatted_mrp) {
			const formatted_mrp = this.escape_html(item.formatted_mrp.replace(/ +/g, ""));
			const discount = this.escape_html(item.discount || "");
			price_html += `
				<span class="text-xs text-slate-400 line-through striked-price">
					${formatted_mrp}
				</span>
				<span class="text-[10px] font-bold text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded-md product-info-green">
					${discount} ${this.escape_html(__("OFF"))}
				</span>
			`;
		}
		
		
		price_html += `</div>`;
		return price_html;
	}

	get_uom_label(uom) {
		if (!uom) return "";
		return window.aracwebshopPrice.escape_attr(
			uom.uom_label || window.aracwebshopPrice.get_uom_label(uom.uom || "", uom.conversion_factor)
		);
	}

	get_stock_availability(item, settings) {
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
					<span class="text-xs font-semibold text-theme-primary bg-theme-primary-light px-2 py-1 rounded-lg">
						${this.escape_html(__("Available on backorder"))}
					</span>
				`;
			}
		}
		return ``;
	}

	get_uom_selection(item, settings) {
		if (!item.uoms || item.uoms.length === 0) return '';
		const use_dropdown = settings && settings.show_uom_in_dropdown;
		const item_code = this.escape_attr(item.item_code || "");

		let uom_html = use_dropdown ? '<div class="w-full">' : '<div class="w-auto flex-shrink-0">';

		if (item.uoms.length > 1) {
			// Always render the hidden data-select for cart compatibility
			uom_html += `
				<select class="hidden uom-select" data-item-code="${item_code}">
			`;
			item.uoms.forEach(uom => {
				const formatted_price = this.escape_attr(uom.formatted_price || "");
				const uom_value = this.escape_attr(uom.uom || "");
				const uom_label = this.get_uom_label(uom);
				const conversion_factor = this.safe_number(uom.conversion_factor, "1");
				const price = this.safe_number(uom.price_list_rate, "0");
				uom_html += `
					<option value="${uom_value}"
							data-conversion="${conversion_factor}"
							data-price="${price}"
							data-formatted-price="${formatted_price}">
						${uom_label}
					</option>
				`;
			});
			uom_html += `</select>`;

			if (use_dropdown) {
				// ─── Styled dropdown ───
				uom_html += `
					<div class="uom-dropdown-wrapper relative w-full">
						<select class="uom-dropdown-select arac-list-uom-select w-full outline-none transition-all duration-200 cursor-pointer shadow-sm hover:shadow" data-item-code="${item_code}">
				`;
				item.uoms.forEach(uom => {
					const formatted_price = this.escape_attr(uom.formatted_price || "");
					const uom_value = this.escape_attr(uom.uom || "");
					const uom_label = this.get_uom_label(uom);
					const conversion_factor = this.safe_number(uom.conversion_factor, "1");
					const price = this.safe_number(uom.price_list_rate, "0");
					uom_html += `<option value="${uom_value}" data-conversion="${conversion_factor}" data-price="${price}" data-formatted-price="${formatted_price}">${uom_label}</option>`;
				});
				uom_html += `
						</select>
						<div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
							<svg class="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
								<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
							</svg>
						</div>
					</div>
				`;
			} else {
				// ─── Default: UOM chip buttons ───
				uom_html += `<div class="flex flex-wrap gap-1.5 uom-chips-container" data-item-code="${item_code}">`;
				item.uoms.forEach((uom, index) => {
					const uom_value = this.escape_attr(uom.uom || "");
					const uom_label = this.get_uom_label(uom);
					const conversion_factor = this.safe_number(uom.conversion_factor, "1");
					const price = this.safe_number(uom.price_list_rate, "0");
					let activeClass = index === 0 
						? "bg-theme-primary text-white shadow-sm shadow-theme-primary/10 font-bold border-theme-primary" 
						: "bg-slate-50 text-slate-600 hover:bg-slate-100 hover:text-slate-800 border-slate-200";
					uom_html += `
						<button type="button" class="uom-chip px-3 py-1 border rounded-lg text-xs font-semibold transition-all duration-200 cursor-pointer ${activeClass}" 
								data-uom="${uom_value}"
								data-conversion="${conversion_factor}"
								data-price="${price}"
								data-formatted-price="${this.escape_attr(uom.formatted_price || "")}">
							${uom_label}
						</button>
					`;
				});
				uom_html += `</div>`;
			}
		} else {
			const uom = item.uoms[0];
			const uom_value = this.escape_attr(uom.uom || "");
			const uom_label = this.get_uom_label(uom);
			const conversion_factor = this.safe_number(uom.conversion_factor, "1");
			if (use_dropdown) {
				uom_html += `
					<input type="hidden" class="selected-uom" 
						   value="${uom_value}"
						   data-conversion="${conversion_factor}"
						   data-item-code="${item_code}">
					<div class="w-full arac-list-uom-label bg-white border border-slate-200 shadow-sm">
						<span class="text-slate-600">${uom_label}</span>
					</div>
				`;
			} else {
				uom_html += `
					<input type="hidden" class="selected-uom" 
						   value="${uom_value}"
						   data-conversion="${conversion_factor}"
						   data-item-code="${item_code}">
					<div class="text-[10px] text-slate-500 font-bold px-2 py-0.5 bg-slate-100 rounded-md inline-block">${uom_label}</div>
				`;
			}
		}

		uom_html += '</div>';
		return uom_html;
	}

	get_primary_button(item, settings) {
		const use_dropdown = settings.show_uom_in_dropdown;
		const item_code = this.escape_attr(item.item_code || "");
		const route = this.safe_internal_url(item.route);

		if (item.has_variants) {
			if (use_dropdown) {
				return `
					<button class="w-full arac-list-uom-btn bg-slate-800 hover:bg-slate-900 text-white shadow-sm hover:shadow-md active:scale-[0.97] transition-all btn-explore-variants gap-1.5 whitespace-nowrap" data-item-code="${item_code}" data-route="${route}">
						<svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<rect x="3" y="3" width="7" height="7"></rect>
							<rect x="14" y="3" width="7" height="7"></rect>
							<rect x="14" y="14" width="7" height="7"></rect>
							<rect x="3" y="14" width="7" height="7"></rect>
						</svg>
						<span>${this.escape_html(__("Options"))}</span>
					</button>
				`;
			}
			return `
				<button class="arac-list-uom-btn bg-slate-800 hover:bg-slate-900 text-white shadow-sm hover:shadow-md hover:shadow-slate-800/10 active:scale-[0.98] transition-all flex items-center gap-2 btn-explore-variants whitespace-nowrap shrink-0" data-item-code="${item_code}" data-route="${route}">
					<span>${this.escape_html(__("View Options"))}</span>
					<svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<line x1="5" y1="12" x2="19" y2="12"></line>
						<polyline points="12 5 19 12 12 19"></polyline>
					</svg>
				</button>
			`;
		} else if (settings.enabled && (settings.allow_items_not_in_stock || item.in_stock)) {
			if (use_dropdown) {
				const action_label = this.escape_html(settings.enable_checkout ? __("Cart") : __("Quote"));
				// ─── Cart button for dropdown mode ───
				return `
					<div class="btn-container w-full">
						<button class="w-full arac-list-uom-btn bg-theme-primary hover:bg-theme-primary-hover text-white shadow-sm hover:shadow-md hover:shadow-theme-primary/15 active:scale-[0.97] transition-all btn-add-to-cart-list gap-1.5 whitespace-nowrap ${ item.in_cart ? 'hidden' : '' }" data-item-code="${item_code}">
							<svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
								<line x1="3" y1="6" x2="21" y2="6"></line>
								<path d="M16 10a4 4 0 0 1-8 0"></path>
							</svg>
							<span>${action_label}</span>
						</button>
						<a href="/cart" class="${ item.in_cart ? '' : 'hidden' } go-to-cart block w-full">
							<button class="w-full arac-list-uom-btn bg-emerald-600 hover:bg-emerald-700 text-white shadow-sm hover:shadow-md hover:shadow-emerald-600/15 active:scale-[0.97] transition-all gap-1.5 whitespace-nowrap">
								<svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
									<path d="M22 11.08V12a10 10 0 1 1-5.93-11"></path>
									<polyline points="22 4 12 14.01 9 11.01"></polyline>
								</svg>
								<span>${action_label}</span>
							</button>
						</a>
					</div>
				`;
			}
			const add_label = this.escape_html(settings.enable_checkout ? __("Add to Cart") : __("Add to Quote"));
			const go_label = this.escape_html(settings.enable_checkout ? __("Go to Cart") : __("Go to Quote"));
			// ─── Default: full-width button with text ───
			return `
				<div class="btn-container flex items-center gap-2">
					<button class="arac-list-uom-btn bg-theme-primary hover:bg-theme-primary-hover text-white shadow-sm hover:shadow-md hover:shadow-theme-primary/15 active:scale-[0.98] transition-all flex items-center gap-2 btn-add-to-cart-list whitespace-nowrap shrink-0 ${ item.in_cart ? 'hidden' : '' }" data-item-code="${item_code}">
						<svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
							<line x1="3" y1="6" x2="21" y2="6"></line>
							<path d="M16 10a4 4 0 0 1-8 0"></path>
						</svg>
						<span>${add_label}</span>
					</button>
					<a href="/cart" class="${ item.in_cart ? '' : 'hidden' } go-to-cart block">
						<button class="arac-list-uom-btn bg-emerald-600 hover:bg-emerald-700 text-white shadow-sm hover:shadow-md hover:shadow-emerald-600/15 active:scale-[0.98] transition-all flex items-center gap-2 whitespace-nowrap shrink-0">
							<svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M22 11.08V12a10 10 0 1 1-5.93-11"></path>
								<polyline points="22 4 12 14.01 9 11.01"></polyline>
							</svg>
							<span>${go_label}</span>
						</button>
					</a>
				</div>
			`;
		} else {
			const oos_label = __("Out of Stock") !== "Out of Stock" ? __("Out of Stock") : (__("Out of stock") !== "Out of stock" ? __("Out of stock") : (document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl' ? "إنتهى من المخزن" : "Out of Stock"));
			if (use_dropdown) {
				return `
					<div class="w-full arac-list-uom-btn bg-slate-50 border border-slate-100 text-slate-400 select-none whitespace-nowrap gap-1.5">
						<svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="12" cy="12" r="10"></circle>
							<line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
						</svg>
						<span>${this.escape_html(oos_label)}</span>
					</div>
				`;
			}
			return `
				<div class="arac-list-uom-btn bg-slate-50 border border-slate-100 text-slate-400 select-none whitespace-nowrap gap-1.5 shrink-0">
					<svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<circle cx="12" cy="12" r="10"></circle>
						<line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
					</svg>
					<span>${this.escape_html(oos_label)}</span>
				</div>
			`;
		}
	}

	escape_attr(value) {
		return window.aracwebshopPrice.escape_attr(value);
	}

	escape_html(value) {
		return window.aracwebshopPrice.escape_html(value);
	}

	safe_color(value, fallback) {
		return window.aracwebshopPrice.safe_color(value, fallback);
	}

	safe_image_url(value) {
		return window.aracwebshopPrice.safe_image_url(value);
	}

	safe_internal_url(value) {
		return window.aracwebshopPrice.safe_internal_url(value);
	}

	safe_number(value, fallback = "") {
		const number = Number(value);
		return Number.isFinite(number) ? String(number) : fallback;
	}
};
